import * as AreaAction from '../actions/area'
import { Area } from '../models'

export interface State {
  resourceId: number
  areas: Area[]
}

const initialState: State = {
  resourceId: null,
  areas: []
}

export function videoReducer(state: State = initialState, action: AreaAction.VideoAll): State {
  switch (action.type) {
    case AreaAction.INIT_AREAS_ON_VIDEO: {
      return {
        resourceId: null,
        areas: []
      }
    }
    case AreaAction.LOAD_AREAS_ON_VIDEO: {
      return {
        resourceId: action.videoId,
        areas: action.areas.sort((a, b) => a.position - b.position)
      }
    }
    case AreaAction.ADD_AREA_ON_VIDEO: {
      return {
        ...state,
        areas: [...state.areas, action.area].sort((a, b) => a.position - b.position)
      }
    }
    case AreaAction.REMOVE_AREA_ON_VIDEO: {
      const removeIndex = state.areas.findIndex((e) => e.id === action.areaId)
      // 存在しなければ何もしない
      if(removeIndex === -1) return state

      // 削除
      state.areas.splice(removeIndex, 1)

      return {
        ...state,
        areas: [...state.areas]
      }
    }

    default: {
      return state
    }
  }
}

export function staticContentReducer(state: State = initialState, action: AreaAction.StaticContentAll): State {
  switch (action.type) {
    case AreaAction.INIT_AREAS_ON_STATIC_CONTENT: {
      return {
        resourceId: null,
        areas: []
      }
    }
    case AreaAction.LOAD_AREAS_ON_STATIC_CONTENT: {
      return {
        resourceId: action.staticContentId,
        areas: action.areas.sort((a, b) => a.position - b.position)
      }
    }
    case AreaAction.ADD_AREA_ON_STATIC_CONTENT: {
      return {
        ...state,
        areas: [...state.areas, action.area].sort((a, b) => a.position - b.position)
      }
    }
    case AreaAction.REMOVE_AREA_ON_STATIC_CONTENT: {
      const removeIndex = state.areas.findIndex((e) => e.id === action.areaId)
      // 存在しなければ何もしない
      if(removeIndex === -1) return state

      // 削除
      state.areas.splice(removeIndex, 1)

      return {
        ...state,
        areas: [...state.areas]
      }
    }

    default: {
      return state
    }
  }
}



// WEBPACK FOOTER //
// ./src/reducers/area.ts